import React from 'react';
import { useData } from '../store/DataContext';
import { AdminDashboard } from './admin/AdminDashboard';
import { ReceptionDashboard } from './reception/ReceptionDashboard';
import { NursingDashboard } from './nursing/NursingDashboard';
import { ClinicianDashboard } from './clinician/ClinicianDashboard';
import { LaboratoryDashboard } from './laboratory/LaboratoryDashboard';
import { RadiologyDashboard } from './radiology/RadiologyDashboard';
import { PharmacyModule } from './pharmacy/PharmacyModule';
export const DashboardRouter: React.FC = () => {
  const {
    currentUser
  } = useData();
  if (!currentUser) return null;
  switch (currentUser.role) {
    case 'Administrator':
      return <AdminDashboard data-id="element-2900" data-mp="1gmdf25khvxm5" />;
    case 'Reception':
      return <ReceptionDashboard data-id="element-2901" data-mp="1gn6awbhx12pi" />;
    case 'Nursing':
      return <NursingDashboard data-id="element-2902" data-mp="12mc23rqygzqb" />;
    case 'Clinician':
      return <ClinicianDashboard data-id="element-2903" data-mp="12nneuh2dphtk" />;
    case 'Laboratory':
      return <LaboratoryDashboard data-id="element-2904" data-mp="17m879ube2x7g" />;
    case 'Radiology':
      return <RadiologyDashboard data-id="element-2905" data-mp="17nrmdhlb727n" />;
    case 'Pharmacy':
    case 'Pharmacy Manager':
      return <PharmacyModule data-id="element-2906" data-mp="24a9hma3d4vz8" />;
    default:
      return <div data-id="element-2907" data-mp="2074h2d2uf4d8">Unknown role</div>;
  }
};